import loadable from '@loadable/component';
import { OverlaySpinner } from '@ankr.com/ui';
import { Navigate } from 'react-router';

import { BillingAccessGuard } from 'modules/billing/components/BillingAccessGuard';
import { PageWithBillingTabs } from 'modules/common/components/PageWithBillingTabs';
import { homeRoutesConfig } from 'domains/home/routes';
import { ChainProvider } from 'modules/chains/components/ChainsSelectWithContext/ChainProvider';
import { StatsChainSelectorsProvider } from 'modules/chains/components/StatsChainSelectorsProvider';

const UsagePage = loadable(
  async () => {
    const module = await import('./UsagePage');

    return module.UsagePage;
  },
  {
    fallback: <OverlaySpinner />,
  },
);

const homePath = homeRoutesConfig.home.generatePath();

export const UsagePageContainer = () => {
  return (
    <PageWithBillingTabs>
      <BillingAccessGuard
        fallback={<Navigate to={homePath} replace />}
        premissionFallback={<OverlaySpinner />}
      >
        <ChainProvider>
          <StatsChainSelectorsProvider>
            <UsagePage />
          </StatsChainSelectorsProvider>
        </ChainProvider>
      </BillingAccessGuard>
    </PageWithBillingTabs>
  );
};
